import React from "react";
import LandingLayout from "../landing/LandingLayout";
import { BookDemoPage } from "../landing/BookDemoPage";

export default function BookDemo() {
  return (
    <LandingLayout>
      <BookDemoPage />
    </LandingLayout>
  );
}
